import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AUTH } from "helpers/routes";

import styles from "./styles.module.scss";

const RegistrationNavigation = () => {
    const { t } = useTranslation();
    const location = useLocation();

    return (
        <div className={styles.navigation}>
            {location.pathname === AUTH.login && (
                <Link to={AUTH.forgot} className={styles.button} state={{ modal: true }}>
                    {t("login.forgot_password")}
                </Link>
            )}
            {location.pathname === AUTH.forgot && (
                <Link to={AUTH.login} className={styles.button} state={{ modal: true }}>
                    {t("login.remember_password")}
                </Link>
            )}
            {location.pathname === AUTH.registration && (
                <Link to={AUTH.login} className={styles.button} state={{ modal: true }}>
                    {t("login.sign_in")}
                </Link>
            )}
            {(location.pathname === AUTH.login || location.pathname === AUTH.forgot) && (
                <p>
                    {t("login.no_account_grey")}
                    &nbsp;
                    <Link to={AUTH.registration} className={styles.button} state={{ modal: true }}>
                        {t("login.sign_up")}
                    </Link>
                </p>
            )}
        </div>
    );
};

export default RegistrationNavigation;
